import { useState } from 'react'

import { Box, Button, type Dimensions, Form, Text } from '@factorialco/deprecated-design-system'
import { CoffreFortStatusDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import FailedModal from 'modules/coffrefortnumerique/components/FailedModal'
import CoffreFortNumeriqueTag, {
  nextCronCalendar,
} from 'modules/coffrefortnumerique/components/Tag'
import { CoffreFortNumeriqueFailedTag } from 'modules/coffrefortnumerique/components/Tag/FailedTag'
import { State } from 'modules/coffrefortnumerique/lib/enums'
import { Stateable } from 'modules/coffrefortnumerique/lib/enums'

interface Props {
  id: number
  type: Stateable
  padding?: Dimensions | null
}

const CoffreFortNumeriqueForm = ({ id, type, padding }: Props) => {
  const [failedModal, setFailedModal] = useState(false)

  const { data: coffreFortData } = useQuery(CoffreFortStatusDocument, {
    variables: {
      stateableId: id,
      stateableType: type,
    },
  })
  const status = coffreFortData?.coffreFortNumerique.statusesConnection.nodes[0]

  const onClickFailedModal = () => {
    setFailedModal(true)
  }

  const onCloseFailedModal = () => {
    setFailedModal(false)
  }

  if (status?.state === undefined || null) {
    return (
      <Box paddingTop="s24">
        <CoffreFortNumeriqueFailedTag />
      </Box>
    )
  }

  const showTagOnly = status.stateableType === Stateable.Document
  const modalButton = status.state === State.Failed

  if (showTagOnly) {
    return (
      <Box paddingTop="s24">
        <CoffreFortNumeriqueTag status={status} />
      </Box>
    )
  }

  return (
    <>
      <Box paddingY="s16">
        <Form withBackground padding={padding}>
          <Text.Normal weight="medium">
            {i18n.t('settings.edit_company.coffre_fort_numerique_form.card_title')}
          </Text.Normal>

          <CoffreFortNumeriqueTag status={status} />

          {modalButton && (
            <Box alignItems="flexEnd">
              <Button onClick={onClickFailedModal} type="secondary">
                {i18n.t('settings.edit_company.coffre_fort_numerique_form.see_errors')}
              </Button>
            </Box>
          )}
        </Form>
      </Box>

      {failedModal && (
        <FailedModal
          onCloseFailedModal={onCloseFailedModal}
          errorMessage={status.lastResponse}
          nextCron={nextCronCalendar()}
        />
      )}
    </>
  )
}

export default observer(CoffreFortNumeriqueForm)
